import { useState } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

export default function OrganizationLogin() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async () => {
    if (!username || !password) {
      setError('请输入用户名和密码')
      return
    }
    setError('')
    setLoading(true)
    try {
      const res = await fetch('https://api.boxiaotu.cn/api' + '/institutions/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: username, password })
      })
      const data = await res.json()
      if (data.success) {
        localStorage.setItem('cms_token', data.token)
        localStorage.setItem('cms_institution_id', data.institution?.id || '')
        localStorage.setItem('boxiaotu_token', data.token)
        localStorage.setItem('boxiaotu_institution_id', data.institution?.id || '')
        localStorage.setItem('cms_user', JSON.stringify(data.user))
        localStorage.setItem('cms_institution_id', data.user.institutionId || '')
        localStorage.setItem('cms_courseware', data.user.coursewareEnabled ? '1' : '0')
        localStorage.setItem('cms_plan', data.user.plan || 'basic')
        localStorage.setItem('boxiaotu_token', data.token)
        localStorage.setItem('boxiaotu_user', JSON.stringify(data.user))
        localStorage.setItem('boxiaotu_institution_id', data.user.institutionId || '')
        localStorage.setItem('boxiaotu_courseware', data.user.coursewareEnabled ? '1' : '0')
        window.location.reload()
      } else {
        setError(data.message || '登录失败')
      }
    } catch {
      setError('网络错误，请检查后端服务是否启动')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 40, width: 360, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 8 }}>企业登录</h2>
        <p style={{ textAlign: 'center', color: '#999', marginBottom: 24, fontSize: 13 }}>博小兔企业管理后台</p>

        {error && (
          <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', color: '#999', padding: '10px 12px', borderRadius: 4, marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>手机号</label>
          <input
            type="text"
            placeholder="请输入申请时填写的手机号"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>密码</label>
          <input
            type="password"
            placeholder="请输入密码"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }}
          />
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{ width: '100%', padding: '10px 12px', background: '#667eea', color: '#fff', border: 'none', borderRadius: 4, fontSize: 15, cursor: 'pointer' }}
        >
          {loading ? '登录中...' : '登录'}
        </button>

        <div style={{ marginTop: 16, fontSize: 12, color: '#999', textAlign: 'center' }}>
          
        </div>
      </div>
    </div>
  )
}